import { configureStore } from "@reduxjs/toolkit";

import remoteElaborations from "../feature/object/remote-elaborations-slice";
import docPropertiesReducer from "../feature/docProperties/doc-properties-slice";
import navigationsSlice from "../feature/general/navigation-slice";
import sessionSettings from "../feature/general/session-settings-slice";
import configurations from "../feature/settings/configurations-slice";
import externalConfigs from "../feature/settings/external-configs-slice";
import panelMessage from "../feature/panelMessage/panelMessage-slice";
import downloadDocumentCopy from "../feature/document/download-document-slice";
import askAiChatReducer from "../feature/chat/askai-chat-slice";
import validationReducer from "../feature/validation/validation-slice";
import outlineSearchReducer from "../feature/cpm/outline-search-slice";

export const store = configureStore({
  reducer: {
    // settings: settingsReducer,
    configurationState: configurations,
    externalConfigurations: externalConfigs,
    sessionSettings: sessionSettings,
    // user: userReducer,
    remoteElaborations: remoteElaborations,
    navigation: navigationsSlice,
    // officeDocument: officeDocumentSlice,
    panelMessage: panelMessage,
    downloadDocumentCopy,
    docProperties: docPropertiesReducer,
    askAiChat: askAiChatReducer,
    validation: validationReducer,
    outlineSearch: outlineSearchReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;
